enum TimeFormatType {
  '12 hour',
  '24 hour'
}

export default TimeFormatType
